import { defineComponent } from "vue";

import { ApplicationEnum } from "../../../enums/enums";
import { IReassignVisitDetails } from "../../../interfaces/i-reassign-visit";

import EvvDetailsHomeCare from "../../../pages-vue/CentralCalendar/PatientCalendar/components/EvvDetailsHomeCare/EvvDetailsHomeCare.vue";
import EvvDetailsHomeHealth from "../../../pages-vue/CentralCalendar/PatientCalendar/components/EvvDetailsHomeHealth/EvvDetailsHomeHealth.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        EvvDetailsHomeCare,
        EvvDetailsHomeHealth
    },

    data() {
        return {
            dialogReference: this.dialogRef as any,
            options: {} as IReassignVisitDetails,
            applicationEnum: ApplicationEnum,
            employeeList: [],
            isLoading: false,
            isSaving: false
        };
    },

    created() {
        this.options = Object.assign({}, this.dialogReference.data.visitDetails);
    },

    methods: {
        cancel() {
            this.dialogReference.close();
        },

        ok() {
            this.dialogReference.close("success");
        }
    }
});
